import { deserialize, fetchWrapper } from '../fetch';
import { Feedback } from './interface';

export const addFeedback = async (feedback: Feedback): Promise<number> => {
  const url = new URL('/app/v1/feedback', API_BASE_URL);
  return deserialize(
    await fetchWrapper(url.href, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(feedback),
    })
  );
};
